import React from 'react';

import { Button, Input, Select } from '@chakra-ui/react';

import AddIcon from '@/assets/AddIcon';
import { COLORS, ROLES } from '@/common/constants';

import '../styles/ListPage.css'
import MonthSelector from '@/components/Dashboard/MonthSelector';

interface SearchAndFilterProps {
    searchValue: string;
    setSearchValue: (value: string) => void;
    statusValue: string;
    setStatusValue: (value: string) => void;
    typeValue: string;
    setTypeValue: (value: string) => void;
    onSearch: () => void;
    onAdd: () => void;
    role: string;
    month: number;
    year: number;
    setMonth: (month: number) => void;
    setYear: (year: number) => void;
    isSmallScreen: boolean;
    handleExportToExcel: () => void;
    // added requestor props
    requestors?: { id: string; name: string }[];
    requestorValue?: string;
    setRequestorValue?: (value: string) => void;
}

const SearchAndFilter: React.FC<SearchAndFilterProps> = ({
    searchValue,
    setSearchValue,
    statusValue,
    setStatusValue,
    onSearch,
    role,
    onAdd,
    month,
    year,
    setMonth,
    setYear,
    isSmallScreen,
    handleExportToExcel,
}) => (
    <div className="table-filter-action-container">
        <div className="table-filter-container">
            <div className="table-filter-input filter-input-width-7">
                <Input
                    placeholder='Search'
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                />
            </div>
            <div className="table-filter-input filter-input-width-4">
                <Select
                    placeholder='All Status'
                    style={{ backgroundColor: 'white' }}
                    value={statusValue}
                    onChange={(e) => setStatusValue(e.target.value)}
                >
                    <option value="0">New</option>
                    <option value="1">In Review</option>
                    <option value="2">Done</option>
                    <option value="4">Is 2nd Download</option>
                    <option value="5">Is Rerequest</option>
                </Select>
            </div>

            {[ROLES.SUPER_ADMIN, ROLES.REQUESTOR].includes(role) ? (
                <MonthSelector month={month} year={year} onChange={(newMonth, newYear) => { setMonth(newMonth); setYear(newYear) }} isStacked={isSmallScreen}  />
            ) : null}
            <div>
                <Button
                    className='table-search-button'
                    bgColor={COLORS.BUTTON.BACKGROUND}
                    color={COLORS.BUTTON.FOREGROUND}
                    variant='solid'
                    borderRadius={10}
                    onClick={onSearch}
                >
                    Search
                </Button>
            </div>

            {[ROLES.SUPER_ADMIN, ROLES.REQUESTOR].includes(role) && (
                <div>
                    <Button
                        className='export-to-excel-button'
                        bgColor={COLORS.BUTTON.BACKGROUND}
                        color={COLORS.BUTTON.FOREGROUND}
                        borderRadius={10}
                        onClick={handleExportToExcel}
                    >
                        Export to Excel
                    </Button>
                </div>
            )}
            {role === ROLES.REQUESTOR && (
                <>
                    <div className="table-filter-separator"/>
                    <Button
                        leftIcon={<AddIcon />}
                        bgColor={COLORS.BUTTON.BACKGROUND}
                        color={COLORS.BUTTON.FOREGROUND}
                        className='table-add-button'
                        variant='solid'
                        borderRadius={10}
                        onClick={onAdd}
                    >
                        Add SIRE Review
                    </Button>
                </>
            )}
        </div>
    </div>
);

export default SearchAndFilter;
